import { makeAutoObservable } from 'mobx';
import { tmsScreenServices } from 'services/tmsScreenServices';

export class CommonStore {
  constructor() {
    makeAutoObservable(this);
  }

  fetchMSSalesSummaryData = async (gfc: number) => {
    try {
      const data = await tmsScreenServices.getTMSSalesSummary(gfc);
      return data;
    } catch (error) {
      console.log('fetchSalesSummaryData => ', error);
      throw error;
    }
  };

  fetchSalesPlanSalesSummaryData = async (gfc: number) => {
    try {
      const data = await tmsScreenServices.getSalesPlanSalesSummary(gfc);
      return data;
    } catch (error) {
      console.log('fetchSalesSummaryData => ', error);
      throw error;
    }
  };
}
